import { render, staticRenderFns } from "./Asset-Preview.vue?vue&type=template&id=5edd3f8c&"
import script from "./Asset-Preview.vue?vue&type=script&lang=ts&"
export * from "./Asset-Preview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports